module.exports = __webpack_public_path__ + "static/img/boothStep3.f73200d2.jpg";